import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMutableRef } from '@carnica/utils/hooks';
import { useEffect, useState } from 'react';
export var useManyElementsInView = function useManyElementsInView(nodeRefs, params) {
  var _ref = params || {},
    _ref$intersectionActi = _ref.intersectionActivate,
    intersectionActivate = _ref$intersectionActi === void 0 ? 0.1 : _ref$intersectionActi,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? true : _ref$isActive,
    _ref$deps = _ref.deps,
    deps = _ref$deps === void 0 ? [] : _ref$deps,
    _ref$intersectionOpti = _ref.intersectionOptions,
    intersectionOptions = _ref$intersectionOpti === void 0 ? {} : _ref$intersectionOpti;
  var _useState = useState(Array(nodeRefs.length).fill(true)),
    _useState2 = _slicedToArray(_useState, 2),
    inViewFlags = _useState2[0],
    setIsInViewFlags = _useState2[1];
  var isActiveRef = useMutableRef(isActive);
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      if (isActiveRef.current) {
        setIsInViewFlags(entries.map(function (_ref2) {
          var isIntersecting = _ref2.isIntersecting;
          return isIntersecting;
        }));
      }
    }, _objectSpread(_objectSpread({}, intersectionOptions), {}, {
      root: null,
      threshold: intersectionActivate
    }));
    nodeRefs.forEach(function (ref) {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
    return function () {
      observer.disconnect();
    };
  }, deps);
  return inViewFlags;
};
export var useElementInView = function useElementInView(nodeRef, params) {
  return useManyElementsInView([nodeRef], params)[0];
};